var defaultStyles = {
  "root": "Base-Pagination",
  "item": "Base-Pagination--Item",
  "active": "Base-Pagination--Active",
  "arrow": "Base-Pagination--Arrow"
};

export { defaultStyles as default };
